"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.file_generatedLoanTape = void 0;
const _ = __importStar(require("lodash"));
const common_1 = require("@finley-technologies/common");
const commonTapeNode_1 = require("../../commonTapeNode");
const utils = __importStar(require("../../utils"));
const types_1 = require("./types");
const { isNode, isIntermediateRecord, ...otherProps } = (0, commonTapeNode_1.commonTapeNodeUtils)(types_1.nodeType, types_1.artifactType, types_1.UIConfigSchema);
// create a new UI node of this type.
const createNewNode = ({ id, creditFacilitySlug, loanProductSlug, suggestedSerialNumber, nodeToCopy, }) => {
    const friendlyName = `Gen Loan Tape`;
    const nodeData = {
        metadata: {
            tapeBuilderNodeId: id,
            tapeBuilderNodeType: types_1.nodeType,
        },
        configuration: {
            artifactSlug: `${_.camelCase(friendlyName)}_${suggestedSerialNumber}`,
            creditFacilitySlug,
            loanProductSlug,
            externalReceivableId: 'external_receivable_Id',
            rawExternalReceivableIdField: 'external_receivable_Id',
            rawMasterLoanTapeArtifactSlug: null,
            externalAssignmentField: null,
            signaledAssignmentValueMapping: [],
            loanTapeType: 'preassignedLoanTape',
        },
    };
    if (nodeToCopy) {
        (0, common_1.finleyAssert)(isNode(nodeToCopy), `node must be a ${types_1.nodeType} node`);
        nodeData.configuration = _.cloneDeep(nodeToCopy.configuration);
        nodeData.configuration.artifactSlug = utils.updateArtifactSlug(nodeData.configuration.artifactSlug, suggestedSerialNumber);
    }
    return nodeData;
};
/*
 * validate the configuration for the node. This checks shape as well
 * logical correctness.
 * This function should validate the config wrt rest of the graph as well.
 * if there is an error it should return an array of error messages.
 * if there are no errors it should return an empty array.
 */
const hasValidConfig = ({ graph, node, getUINode, }) => {
    (0, common_1.finleyAssert)(isNode(node), `node must be a ${types_1.nodeType} node`);
    const errors = utils.checkEdges({
        node,
        graph,
        isAllowedInputNode: (uiNode) => uiNode.isOperation && uiNode.operationType === 'tapebuilder_postSanitize',
        getUINode,
        minInputs: 1,
        maxInputs: 1,
        minOutputs: 1,
        maxOutputs: 100, // there could be many outputs to tapes.
    });
    return errors;
};
// validate given IntermediateRecord.
// this is called after initialial Config validation is done
// and the intermediate record is generated.
// here an instance of ITapeBuilder is available, which can be used
// to inspect any Tape definitions.
const validateIntermediateTape = ({ tape, graph, tapeBuilder, creditFacilitySlugs, loanProductSlugs, }) => {
    (0, common_1.finleyAssert)(isIntermediateRecord(tape), `validateIntermediateTape: tape is not an ${types_1.artifactType}`);
    const { id, creditFacilitySlug, loanProductSlug, artifactSlug } = tape;
    const { externalReceivableId, externalAssignmentField, signaledAssignmentValueMapping, rawMasterLoanTapeArtifactSlug, } = tape.configuration;
    const configErrors = [];
    // check creditFacilitySlug value.
    if (creditFacilitySlug !== null &&
        !creditFacilitySlugs.includes(creditFacilitySlug)) {
        configErrors.push(`validateIntermediateTape: [${artifactSlug}] has invalid creditFacilitySlug: ${creditFacilitySlug}`);
    }
    // check loanProductSlug value.
    if (loanProductSlug !== null && !loanProductSlugs.includes(loanProductSlug)) {
        configErrors.push(`validateIntermediateTape: [${artifactSlug}] has invalid loanProductSlug: ${loanProductSlug}`);
    }
    const tapeDefinitionResult = tapeBuilder.generateTapeDefinition(id);
    (0, common_1.finleyAssert)(tapeDefinitionResult.isValid, 'loan tape tapeDefinition is not valid');
    (0, common_1.finleyAssert)(tapeDefinitionResult.data, 'validateIntermediateTape: loan tape tapeDefinition is null');
    const { baseFields } = tapeDefinitionResult.data;
    const hasSignaledAssignments = signaledAssignmentValueMapping && signaledAssignmentValueMapping.length > 0;
    const externalAssignmentFieldConfigured = externalAssignmentField !== null;
    // check signaledAssignmentValueMapping and externalAssignmentField
    if (hasSignaledAssignments !== externalAssignmentFieldConfigured) {
        configErrors.push(`validateIntermediateTape: [${artifactSlug}] has inconsistent signaledAssignmentValueMapping and externalAssignmentField`);
    }
    // ensure that signaledAssignmentValueMapping has valid creditFacilitySlugs
    if (hasSignaledAssignments) {
        signaledAssignmentValueMapping.forEach(({ creditFacilitySlug: cfSlug }) => {
            if (!creditFacilitySlugs.includes(cfSlug)) {
                configErrors.push(`validateIntermediateTape: [${artifactSlug}] references invalid [creditFacilitySlug:${cfSlug}] in signaledAssignmentValueMapping`);
            }
        });
    }
    // ensure that tape has the externalAssignmentField if configured
    if (externalAssignmentFieldConfigured) {
        const baseField = baseFields.find(({ field }) => field === externalAssignmentField);
        if (!baseField) {
            configErrors.push(`validateIntermediateTape: [${artifactSlug}] does not have [externalAssignmentField:${externalAssignmentField}]`);
        }
    }
    // ensure that tape has the externalReceivableId
    const baseField = baseFields.find(({ field }) => field === externalReceivableId);
    if (!baseField) {
        configErrors.push(`validateIntermediateTape: [${artifactSlug}] does not have [externalReceivableId:${externalReceivableId}]`);
    }
    // Ensure that tape's "rawMasterLoanTapeArtifactSlug" is properly configured
    if (!rawMasterLoanTapeArtifactSlug) {
        configErrors.push(`validateIntermediateTape: [${artifactSlug}] needs to set up "rawMasterLoanTapeArtifactSlug"`);
    }
    else {
        const artifactInputs = utils.getAllInputsForArtifact({
            targetArtifactId: id,
            ...graph,
        });
        const validRawMasterArtifactSlugs = artifactInputs.map((inputTape) => inputTape.artifactSlug);
        // a tape should be allowed to use its own slug as rawMasterLoanTapeArtifactSlug
        validRawMasterArtifactSlugs.push(artifactSlug);
        const usingValidArtifactSlug = validRawMasterArtifactSlugs.includes(rawMasterLoanTapeArtifactSlug);
        if (!usingValidArtifactSlug) {
            configErrors.push(`validateIntermediateTape: [${artifactSlug}] references invalid [rawMasterLoanTapeArtifactSlug:${rawMasterLoanTapeArtifactSlug}]`);
        }
    }
    return configErrors;
};
/**
 * Represents a UI node with various properties and methods.
 */
exports.file_generatedLoanTape = {
    // what should node say on the tape-buider node creation menu.
    nodeTypeText: 'Loan Tape',
    // what is the node type. must be one of the constants defined in TapeBuilderNodeType
    nodeType: types_1.nodeType,
    // expose artifactType
    artifactType: types_1.artifactType,
    isOperation: false,
    isRaw: false,
    isFinal: false,
    // operatin nodes dont render badges.
    badgeTexts: ['Generated', 'LoanTape'],
    // creates sample configuration for this node.
    createNewNode,
    // typeguard that checks if the node is of this type.
    isNode,
    isIntermediateRecord,
    ...otherProps,
    // validate the configuration for the node for logical correctness
    hasValidConfig,
    // validate generated config
    validateIntermediateTape,
};
//# sourceMappingURL=uinode.js.map